import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { CODE_ENUM } from '@/common'
import { ref } from 'vue'
import { queryOrgTreeList } from '@/api'
import { isEmpty } from 'lodash'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const deepFormat = (
  list: any,
  level = 0,
  topOrgName = '-',
  parentOrgId?: any
) => {
  if (isEmpty(list)) {
    return
  }
  return list.map((item: any) => {
    const { children, id, name, ...p } = item
    return {
      ...p,
      name,
      value: id,
      id,
      label: name,
      children: deepFormat(children, level + 1, name, id),
      level: level + 1,
      topOrgName,
      parentOrgId,
      class: 'node_' + id,
    }
  })
}

const orgList: any = ref([])
const queryOrg = async () => {
  const res: any = await queryOrgTreeList()
  if (res?.code === CODE_ENUM.SUCCESS) {
    const result = deepFormat([res.data])

    orgList.value = result
  }
}

queryOrg()

return (_ctx: any,_cache: any) => {
  const _component_el_tree_select = _resolveComponent("el-tree-select")!

  return (_openBlock(), _createBlock(_component_el_tree_select, {
    data: orgList.value,
    "render-after-expand": false,
    "default-expand-all": "",
    "check-strictly": ""
  }, null, 8, ["data"]))
}
}

})